import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class CheckUserNameBySmsTokenForLoginAccountUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute(name: string) {
    return this.repo.checkUserNameBySmsTokenForLoginAccount(name);
  }
}
